export default "__VITE_ASSET__ld0$g9I5__"